module.exports = "/images/vendor/flag-icon-css/flags/4x3/sd.svg?c466d90ea717a1f99f0ca61fd244b0f3";